import { createFileRoute, Link } from "@tanstack/react-router";
import heroPartners from "@/assets/hero/hero-partners.jpg.asset.json";

const HERO = {
  src: heroPartners.url,
  alt: "A team of professional advisors — banking, legal, insurance, and title — standing together in a modern office ready to help real estate investors",
};
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader } from "@/components/site/Blocks";
import { partners } from "@/data/partners";
import { PartnerCard, PartnerDisclosure } from "@/components/site/PartnerBlocks";
import { buildHead } from "@/lib/seo-head";
import { PageEssentials, PageOutro } from "@/components/site/PageEssentials";

const URL = "/partners";
const KEYWORDS = [
  "real estate investor partners",
  "LLC formation for investors",
  "landlord insurance partner",
  "business banking for investors",
  "property management software",
  "ITIN for foreign national investors",
  "title company for investors",
  "DUNS number business credit",
  "investor entity setup services",
  "vetted lender partners",
].join(", ");

export const Route = createFileRoute("/partners")({
  head: () =>
    buildHead({
      title: "Investor Partners — Banking, LLC, Insurance, Title | Simply Approved",
      description:
        "Vetted partners for real estate investors: business banking, LLC formation, DUNS and business credit, landlord insurance, property management software, ITIN, and title services.",
      url: URL,
      keywords: KEYWORDS,
      breadcrumbs: [
        { name: "Home", url: "/" },
        { name: "Partners", url: URL },
      ],
      service: { name: "Investor Support Partner Network" },
      image: HERO.src,
      imageAlt: HERO.alt,
    }),
  component: PartnersPage,
});

function PartnersPage() {
  return (
    <SiteShell>
      <PageHero
        eyebrow="Partners"
        title="Partners our investor clients use"
        subtitle="Everything around the loan — the entity, the bank account, insurance, software, tax IDs, and title — handled by independent companies we work with."
        image={HERO}
      />
      <PageEssentials />
      <Section>
        <SectionHeader eyebrow="Vetted partners" title="Set up the business side of your rental portfolio" />
        <div className="mt-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {partners.map((p) => (
            <PartnerCard key={p.slug} partner={p} />
          ))}
        </div>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/apply" className="rounded-md bg-brand-gold px-5 py-3 text-sm font-semibold text-primary-foreground">Start My Approval</Link>
          <Link to="/business-setup" className="rounded-md border border-brand px-5 py-3 text-sm font-semibold text-brand">Business setup hub</Link>
        </div>
        <PartnerDisclosure />
      </Section>
    <PageOutro />
      </SiteShell>
  );
}
